import { useContextState } from "../../../../../../../../hooks/theme"

export const useStyles = () => {
    const { colors } = useContextState()

    return {
        container: {
            position: "relative",
            minWidth: '50px',
            minHeight: '35px',
            '& svg': {
                width: 30,
                height: 30,
                '& path': {
                    //fill: colors.color19
                },
            },
        }
    }
}
